import { render, staticRenderFns } from "./RouteAware.vue?vue&type=template&id=5b528b53&"
import script from "./RouteAware.vue?vue&type=script&lang=ts&"
export * from "./RouteAware.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports